import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseDesc, BaseTitle, BaseContainer, BaseImage,
} from './styles';

const vPadding = 110;
const Container = styled(BaseContainer)`
  margin-top: ${vPadding + 8}px;
  ${props => (!props.theme.isMobile && `
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

const SImage = styled(BaseImage)`
  ${props => (!props.theme.isMobile && `
    max-width: 528px;
    max-height: 478px;
  `)};
`;

export default function ReachOut() {
  const { reachOut, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#enquiries', vPadding);

  return (
    <Container id="enquiries">
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <SImage src={reachOut} />
      </Plx>
      <Plx className="right-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Features</SectionName>
        <BaseTitle>Reach out directly to contributors you&apos;re impressed with</BaseTitle>
        <BaseDesc>
          If you like the way our approved contributors think, initiate contact with our Contact
          Button to quickly receive performance reports, product disclosure statements or even
          arrange a meeting with a fund manager.
        </BaseDesc>
      </Plx>
    </Container>
  );
}
